<mat-card class="mfa-card">
  <mat-toolbar color="primary">
    <mat-toolbar-row>
      <h2 class="truncate">Two-Factor Authentication</h2>
    </mat-toolbar-row>
  </mat-toolbar>
  <mat-card-content>
    <form [formGroup]="mfaForm">
      <p class="description">
        Enter the 6-digit code sent to the email address<br>
        listed in your Comfort Zone User Profile.
      </p>
      <mat-form-field class="code-input" appearance="outline">
        <mat-label>Verification Code</mat-label>
        <input matInput 
               [formControl]="mfaCode" 
               required
               maxlength="6"
               placeholder="000000"
               autocomplete="off">
        <mat-icon matSuffix>lock</mat-icon>
        <mat-error *ngIf="mfaCode.errors?.required">
          Verification code is required
        </mat-error>
        <mat-error *ngIf="mfaCode.errors?.minlength || mfaCode.errors?.maxlength">
          Code must be 6 digits
        </mat-error>
        <mat-error *ngIf="mfaCode.errors?.invalid">
          Invalid verification code
        </mat-error>
      </mat-form-field>
    </form>
  </mat-card-content>
  <mat-card-actions>
    <div class="row">
      <div class="col-xs-6">
        <div class="button-group">
          <button mat-button mat-dialog-close>Cancel</button>
          <button mat-button 
                  (click)="generateCode()" 
                  [disabled]="resendDisabled">
            Resend Code {{ resendDisabled ? '(' + resendCountdown + ')' : '' }}
          </button>
        </div>
      </div>
      <div class="col-xs-6 end-xs">
        <button mat-flat-button 
                color="primary" 
                (click)="validateCode()" 
                [disabled]="!mfaForm.valid">
          Verify Code
        </button>
      </div>
    </div>
  </mat-card-actions>
</mat-card>